import { type ExamCenterProctorRequestStep } from '@exam-center/graphql';
import { Label, LabelColor } from '@shared/components';

export type ExamCenterProctorRequestStatusLabelVariants = ExamCenterProctorRequestStep;

export const PROCTOR_REQUEST_STATUS_COLOR: Readonly<
  Record<ExamCenterProctorRequestStatusLabelVariants, LabelColor>
> = {
  DRAFT: LabelColor.INFO,
  APPROVED: LabelColor.SUCCESS,
  IN_REVIEW_1: LabelColor.WARNING,
  IN_REVIEW_2: LabelColor.WARNING,
  REJECTED: LabelColor.ERROR,
};

export const PROCTOR_REQUEST_STATUS_TEXT: Readonly<
  Record<ExamCenterProctorRequestStatusLabelVariants, string>
> = {
  DRAFT: 'แบบร่าง',
  APPROVED: 'อนุมัติแล้ว',
  IN_REVIEW_1: 'อยู่ระหว่างอนุมัติ',
  IN_REVIEW_2: 'อยู่ระหว่างอนุมัติ',
  REJECTED: 'ไม่อนุมัติ',
};

interface ExamCenterProctorRequestStatusLabelProps {
  variant: ExamCenterProctorRequestStatusLabelVariants;
}

export default function ExamCenterProctorRequestStatusLabel(
  props: Readonly<ExamCenterProctorRequestStatusLabelProps>,
) {
  const { variant } = props;

  return (
    <Label
      color={PROCTOR_REQUEST_STATUS_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {PROCTOR_REQUEST_STATUS_TEXT[variant]}
    </Label>
  );
}
